uic-popover {
  display: contents;
  position: relative;
}

.uic-popover {
  &__trigger {
    display: block;
  }

  &__panel {
    opacity: 0;
    visibility: hidden;
  }

  &__panel-positioner {
    min-width: 80px;
    pointer-events: none;
    position: absolute;
    z-index: var(--uic-z-index-popover);
  }

  &--open {
    .uic-popover__panel-positioner {
      pointer-events: unset;
    }

    .uic-popover__panel {
      opacity: 1;
      visibility: visible;
    }
  }

  &:not(.uic-popover--open) uic-scrollpanel .simplebar-track.simplebar-vertical {
    pointer-events: none;
  }
}
